<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark>
        <div style="width: 70px;">
          <v-btn @click="routerBack">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>

        <v-toolbar-title
          style="
            position: absolute;
            left: 50%;
            margin: 0;
            padding: 0;
            max-width: 70%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
          class="text-center chat-toolbar-child-name chat-title-custom"
        >
          {{ childName }}
        </v-toolbar-title>

        <div style="width: 70px; margin-left: auto;">
          <v-btn @click="toRecordByDay">
            {{ t('chat.header.record') }}
          </v-btn>
        </div>
      </v-toolbar>

      <v-card tile elevation="0">
        <div class="chat-date-nav">
          <div class="chat-date-nav-year pa-1">
            <h5 class="text-center">{{ t('chat.header.year', '', { year }) }}</h5>
          </div>

          <div class="chat-date-nav-side chat-date-nav-side-left">
            <v-badge
              :content="unReadCount.beforeTheDate"
              :value="unReadCount.beforeTheDate"
              v-if="unReadCount.beforeTheDate > 0"
              color="red"
              :class="{ 'badge-prev-day-en-custom': isEnglishLocale }"
              :offset-x="prevDayUnreadBadgeOffsetX"
              :offset-y="dateNavUnreadBadgeOffsetY">
            </v-badge>
            <v-btn
              @click="toPrevDate"
              class="no-background-hover px-0" 
              variant="text"
            >
              <v-icon color="primary">mdi-chevron-left</v-icon>
              <span class="pink--text text-subtitle-1 mr-1" style="color: #E91E63 !important;">{{ t('chat.header.prevDay') }}</span>
            </v-btn>
          </div>

          <div class="chat-date-nav-center">
            <div class="chat-date-nav-date d-flex align-end">
              <h3>{{ today }}</h3>
              <p style="margin-left: 2px !important; margin-right: 2px !important;">{{ `(${dayOfTheWeek})` }}</p>
            </div>
            <v-icon
              class="chat-date-nav-calendar"
              medium
              :disabled="fetchLoading"
              @click="openCalendarModal">
              mdi-calendar-filter</v-icon>
          </div>

          <div class="chat-date-nav-side chat-date-nav-side-right">
            <v-badge
              :content="unReadCount.afterTheDate"
              :value="!unReadCount.afterTheDate"
              v-if="unReadCount.afterTheDate > 0"
              color="red"
              offset-x="0"
              :offset-y="dateNavUnreadBadgeOffsetY">
            </v-badge>
            <v-btn
              @click="toNextDate"
              class="no-background-hover px-0" 
              variant="text"
            >
              <span class="pink--text text-subtitle-1 ml-1" style="color: #E91E63 !important;">{{ t('chat.header.nextDay') }}</span>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="d-flex w-100 pa-0" style="height:47px;">
          <v-tabs v-model="tabs" fixed-tabs style="margin-left: calc(-50vw + 50%);" slider-color="pink" grow>

            <v-tab href="#chat">
              <p class="pink--text text-subtitle-1 ml-1" style="color: #E91E63 !important;">{{ t('chat.tabs.chat') }}</p>
            </v-tab>
            <v-tab href="#absence">
              <p class="pink--text text-subtitle-1 ml-1" style="color: #E91E63 !important;">{{ t('chat.tabs.absence') }}</p>
            </v-tab>
            <v-tab href="#pickup">
              <p class="pink--text text-subtitle-1 ml-1" style="color: #E91E63 !important;">{{ t('chat.tabs.pickup') }}</p>
            </v-tab>
          </v-tabs>
        </div>
      </v-card>
      <div class="grey-border" />
    </div>

    <!-- チャットタブ -->
    <div
      v-if="tabs === 0"
      :class="`
        chats-wrapper
        d-flex
        flex-column
        no-scroll-bar
      `">
      <v-overlay v-if="isChatMenu" color="rgba(1, 1, 1, 0)">
        <div
          class="chat_menu-wrapper d-flex justify-center align-center"
          @click.self="isChatMenu = false">
          <div
            @click="deleteChat"
            class="chat_menu pa-1 d-flex justify-center align-center"
            :style="`position: absolute; left: ${chatMenuX}px; top: ${chatMenuY}px`"
            v-ripple>
            <p class="text-center" style="user-select: none">{{ t('chat.menu.delete') }}</p>
          </div>
        </div>
      </v-overlay>
      <vue-loading
        loader="bars"
        :active="fetchLoading"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"></vue-loading>
      <div
        v-show="!fetchLoading"
        v-for="c in chats"
        :key="c.chatId + c.createdAt"
        :class="`chat-wrapper d-flex ${
          c.from === null ? 'justify-end align-self-end' : ''
        }`">
        <div
          v-show="c.bodyType === 'message' || c.bodyType === 'groupChat' || c.bodyType === 'absence' || c.bodyType === 'pickup'"
          v-touch:touchhold="showChatMenu(c)"
          style="user-select: none; width: 100%">
          <div
            :class="`
              message-wrapper
              d-flex align-end
              ${c.from === null ? 'justify-end align-self-end' : ''}
            `">
            <div
              v-if="c.from === null"
              class="d-flex align-end blue-grey--text caption flex-shrink-0">
              <div class="meta">
                <p v-if="c.readAt" class="ma-0">{{ t('chat.message.read') }}</p>
                <p class="ma-0 text-right-wrap">{{ formatMinutes(c.deliveredAt) }}</p>
              </div>
            </div>
            <!-- <div
              style="white-space:pre-wrap;user-select: none;"
              :class="`
                ${c.from === null? 'parents-chat' : 'staff-chat' }
                chat-body pa-2 mx-1 mt-1
                ${c.bodyType === 'groupChat'? 'group-chat' :  ''}
              `"
            > -->
            <div
              :class="`
                ${c.from === null ? 'parents-chat' : 'staff-chat'}
                chat-body pa-2 mx-1 mt-1 no-scroll-bar
                ${c.bodyType === 'groupChat' ? 'group-chat' : ''}
              `">
              <span
                v-show="c.bodyType === 'groupChat'"
                class="font-weight-bold"
                >{{ t('chat.message.groupChatLabel') }}</span
              >
              <p
                v-html="escapeAndLinkify(displayChatBody(c))"
                class="autolinked"
                style="white-space: pre-wrap; overflow-wrap: break-word;"
                @click="handleContentClick(c, $event)"
              ></p>
              <!-- <p v-show="c.body">{{ c.body }}</p> -->
              <!-- <p
                class="autolinked"
                v-show="c.body"
                v-html="autoLinked(c.body)"
              ></p> -->
              <div v-if="c.attachmentUrls?.length > 0">
                <div
                  v-for="(au, index) in c.attachmentUrls"
                  :key="au.objectKey">
                  <v-card
                    v-if="!isPdf(au.objectKey)"
                    @click="openChatImg(c, index)"
                    class="pointer mt-1"
                    elevation="0">
                    <v-img :src="au.url ?? undefined" contain></v-img>
                  </v-card>
                  <div v-else>
                    <v-btn
                      class="mt-3 justify-start"
                      color="primary"
                      variant="outlined"
                      block
                      @click="openChatImg(c, index)"
                      :loading="imgLoading">
                      {{ t('chat.message.showAttachment') }}
                    </v-btn>
                  </div>
                </div>
                <v-btn
                  class="mt-1 justify-start"
                  color="primary"
                  variant="outlined"
                  @click="handleSendPdf(c)"
                  :loading="imgLoading">
                  {{ t('chat.message.sendAttachmentByEmail') }}
                </v-btn>
              </div>
            </div>
            <div
              v-if="c.from !== null"
              class="d-flex align-end blue-grey--text caption flex-shrink-0">
              <div class="meta">
                <div v-if="!translatedChats[c.chatId]">
                  <v-btn
                    style="height: 18px; color: #000000; border-color: #000000; border-width: 1px"
                    @click="openTranslateDialog(c)">
                    <v-icon size="small">mdi-google-translate</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn
                    style="height: 16px; color: #000000; border-color: #000000; border-width: 1px"
                    @click="returnTranslate(c.chatId)">
                    <v-icon small>mdi-arrow-u-left-top</v-icon>
                  </v-btn>
                </div>
                <p class="ma-0">{{ formatMinutes(c.deliveredAt) }}</p>
              </div>
            </div>
            <v-btn
              v-if="c.from === null && c.bodyType === 'message'"
              icon
              @click="handleContentClick(c, $event)"
              small
              flat
              class="align-self-center"
            >
              <v-icon>mdi-dots-vertical-circle-outline</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="tabs === 0 && isChatEnabled" class="input-wrapper d-flex">
      <v-textarea
        class="chat_textarea"
        v-model="chatInput"
        auto-grow
        :rules="[rules.counter1000]"
        @focus="chatsScrollToBottom"
        color="primary"
        variant="outlined"
        rows="1"
        row-height="15"
        hide-details
        dense />
      <div class="btn-wrapper">
        <v-btn
          @click="postChats"
          :loading="postLoading"
          class="send-button ml-1"
          color="primary"
          depressed>
          {{ t('chat.input.send') }}
        </v-btn>
      </div>
    </div>

    <!-- 欠席連絡タブ -->
    <div
      v-if="tabs === 1"
      :class="`
        chats-wrapper
        d-flex
        flex-column
        no-scroll-bar
        ${isSafeArea ? '' : 'pb-12'}
      `">
      <v-overlay v-if="isChatMenu" color="rgba(1, 1, 1, 0)">
        <div
          class="chat_menu-wrapper d-flex justify-center align-center"
          @click.self="isChatMenu = false">
          <div
            @click="deleteChat"
            class="chat_menu pa-1 d-flex justify-center align-center"
            :style="`position: absolute; left: ${chatMenuX}px; top: ${chatMenuY}px`"
            v-ripple>
            <p class="text-center" style="user-select: none">{{ t('chat.menu.delete') }}</p>
          </div>
        </div>
      </v-overlay>

      <vue-loading
        v-show="fetchLoading"
        loader="bars"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"></vue-loading>
      <!-- <div
        v-show="!fetchLoading"
        :class="`chat-wrapper d-flex ${c.from === null? 'justify-end align-self-end' : '' }`"
      > -->
      <v-card
        v-if="!fetchLoading && absence !== null && !!absence?.reason"
        class="ma-2">
        <div class="info-wrapper pa-2 mx-1 my-2">
          <v-card-title class="mb-3">
            <p class="body-2 font-weight-bold">{{ t('chat.absence.title') }}</p>
          </v-card-title>

          <div>
            <p style="white-space: pre-wrap">
              {{ formatReason(absence?.reason) }}
            </p>
          </div>

          <div>
            <p v-if="absence.comment" style="white-space: pre-wrap">
              {{ absence.comment }}
            </p>
          </div>

          <div class="mt-2 d-flex justify-center">
            <v-btn
              @click="deleteAbsence"
              :loading="deleteAbsenceLoading"
              color="primary"
              depressed
              >{{ t('chat.action.cancel') }}</v-btn
            >
          </div>
        </div>
      </v-card>

      <div class="pa-1">
        <v-btn
          v-if="!isQuit && !absence?.reason"
          @click="isAbsenceDialog = true"
          class="outline"
          color="primary"
          block
          variant="outlined">
          {{ t('chat.tabs.absence') }}
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="actionDialog">
      <v-card>
        <div class="d-flex flex-column">
          <v-btn v-if="chatType != 'groupChat'" @click="clickDeleteDialog(tempChat)">
            <span>{{ t('chat.menu.delete') }}</span>
            <v-icon end>mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isAbsenceDialog" persistent>
      <absence-modal
        :isOpen="isAbsenceDialog"
        :childId="childId"
        @posted="fetchChats"
        @close="isAbsenceDialog = false" />
    </v-dialog>

    <!-- カレンダー検索機能 -->
    <v-dialog
      v-model="isCalendarDialog"
      width="350px"
      persistent
    >
      <calendar-modal
        v-if="isCalendarDialog"
        :isOpen="isCalendarDialog"
        :childId="childId"
        :calendar="calendar || []" 
        :calendarDate="calendarDate || []"
        @posted="fetchChats"
        @select-date="dateSelected"
        @close="closeCalendarModal" 
        @click:outside="closeCalendarModal"
      />
    </v-dialog>

    <!-- 送迎変更タブ -->
    <div
      v-if="tabs === 2"
      :class="`
        chats-wrapper
        d-flex
        flex-column
        no-scroll-bar
        ${isSafeArea ? '' : 'pb-12'}
      `">
      <v-overlay v-if="isChatMenu" color="rgba(1, 1, 1, 0)">
        <div
          class="chat_menu-wrapper d-flex justify-center align-center"
          @click.self="isChatMenu = false">
          <div
            @click="deleteChat"
            class="chat_menu pa-1 d-flex justify-center align-center"
            :style="`position: absolute; left: ${chatMenuX}px; top: ${chatMenuY}px`"
            v-ripple>
            <p class="text-center" style="user-select: none">{{ t('chat.menu.delete') }}</p>
          </div>
        </div>
      </v-overlay>
      <vue-loading
        v-show="fetchLoading"
        loader="bars"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"></vue-loading>
      <!-- <div
        v-show="!fetchLoading"
        :class="`chat-wrapper d-flex ${c.from === null? 'justify-end align-self-end' : '' }`"
      > -->
      <v-card
        v-if="!fetchLoading && pickup !== null && pickup?.reason"
        class="ma-2">
        <div class="info-wrapper pa-2 mx-1 my-2">
          <v-card-title class="mb-3">
            <p class="body-2 font-weight-bold">{{ t('chat.pickup.title') }}</p>
          </v-card-title>

          <div v-if="pickup.dropOff.time">
            <p>{{ t('chat.pickup.dropOffBy') }}{{ pickup.dropOff.by ? translateParentRelationLabel(pickup.dropOff.by.value) : '' }}</p>
            <p>{{ t('chat.pickup.dropOffTime') }}{{ formatPickupTime(pickup.dropOff.time) }}</p>
          </div>

          <div v-if="pickup.pickup.time">
            <p>{{ t('chat.pickup.pickupBy') }}{{ pickup.pickup.by ? translateParentRelationLabel(pickup.pickup.by.value) : '' }}</p>
            <p>{{ t('chat.pickup.pickupTime') }}{{ formatPickupTime(pickup.pickup.time) }}</p>
          </div>

          <div>
            <p style="white-space: pre-wrap">{{ pickup?.reason }}</p>
          </div>

          <div class="mt-2 d-flex justify-center">
            <v-btn
              @click="deletePickup"
              :loading="deletePickupLoading"
              color="primary"
              depressed>
              {{ t('chat.action.cancel') }}</v-btn
            >
          </div>
        </div>
      </v-card>

      <div class="pa-1">
        <v-btn
          v-if="!isQuit"
          @click="isPickupDialog = true"
          class="outline"
          color="primary"
          block
          variant="outlined">
          {{ t('chat.tabs.pickup') }}
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="isPickupDialog" persistent>
      <pickup-modal
        :isOpen="isPickupDialog"
        :childId="childId"
        @posted="fetchChats"
        @close="isPickupDialog = false" />
    </v-dialog>

    <v-dialog
      class="pt-5"
      v-model="isAttachmentUrls"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card class="pdf_wrapper pt-5">
        <div class="pdf_header_wrapper">
          <v-toolbar class="pdf_header" dark color="primary">
            <v-btn icon dark @click="closeChatImg" absolute>
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-spacer />
            <v-toolbar-title>{{ childName }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
        </div>
        <div class="pdf">
          <div v-for="u in showingUrls" :key="u.objectKey">
            <object
              :data="u.url"
              type="application/pdf"
              width="100%"
              height="100%">
              <iframe 
                :src="u.url" 
                width="100%" 
                height="100%" 
                frameborder="0"
                allowfullscreen
              >
                お使いのブラウザは iframe に対応していません。
              </iframe>
              <div class="fallback-link">
                <a :href="u.url" target="_blank" rel="noopener">
                  PDF をダウンロード
                </a>
              </div>
            </object>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isImgDialog"
      fullscreen
      transition="dialog-bottom-transition">
      <!-- <v-card class="d-flex flex-column" width="100%"> -->
      <v-card width="100%" rounded="b-0" class="img_dialog">
        <v-card
          height="40px"
          class="d-flex justify-end align-center px-2 img_dialog-header"
          rounded="b-0"
          dark
          elevation="0">
          <p class="blue--text" @click="isImgDialog = false">{{ t('chat.action.close') }}</p>
        </v-card>
        <v-card
          height="calc(100vh - 40px)"
          width="100%"
          rounded="0"
          dark
          class="d-flex flex-grow-1">
          <v-img
            class="img_dialog-img"
            width="100%"
            contain
            :src="notPdfImgSrc ?? undefined"
            alt="img"></v-img>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent>
      <v-card>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-title class="headline lighten-2">{{ t('chat.confirm.deleteTitle') }}</v-card-title>
        </div>
        <div v-if="tempChat.body" class="d-flex px-3">
          <v-card-subtitle
            style="white-space: pre-line; user-select: none;"
            class="d-flex justify-center"
            >{{ showLongText(tempChat.body) }}</v-card-subtitle
          >
        </div>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-actions>
            <v-btn color="error" @click="() => (deleteDialog = false)" depressed>
              {{ t('chat.action.cancelBtn') }}
            </v-btn>
            <v-btn
              color="error"
              class="ml-5"
              depressed
              variant="flat"
              @click="deleteChatById()"
              :loading="deleteLoading"
            >
              {{ t('chat.menu.delete') }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="actionDialog">
      <v-card>
        <div class="d-flex flex-column">
          <v-btn v-if="chatType != 'groupChat'" @click="clickDeleteDialog(tempChat)">
            <span>{{ t('chat.menu.delete') }}</span>
            <v-icon end>mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
        <div class="d-flex flex-column">
          <v-btn v-if="chatType != 'groupChat'" @click="onCopyTextCopy()">
            <span>{{ t('chat.menu.copy') }}</span>
            <v-icon end>mdi-content-copy</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isTranslationDialog" persistent max-width="400px">
      <translation-modal
        :isOpen="isTranslationDialog"
        :childId="childId"
        :selectedChat="translationChat"
        @translate="onTranslated"
        @close="isTranslationDialog = false" />
    </v-dialog>

    <email-send-modal
      v-model="isEmailSendDialog"
      :email="this.me?.email"
      :chat-id="this.selectedChat?.chatId"
      @error="sendEmailError"
      @success="sendEmailSuccess"
      @close="isEmailSendDialog = false"
      content-class="email-dialog"
      persistent
    />
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import 'dayjs/locale/en';
import 'dayjs/locale/km';
import { t, locale, dayjsLocale as appDayjsLocale } from '@/i18n';
import { translateParentRelationLabel } from '@/i18n/parentRelationLabel';
dayjs.locale(appDayjsLocale);
import rules from '@/service/ValidRules';
// import VueHighlights, { autoLink, autoHighlight } from 'vue-highlights';
import VRuntimeTemplate from 'v-runtime-template';

import { isSafeAreaDisplay } from '@/service/isSafeAreaDisplay';
import { formatChatTime, formatPickupTime } from '@/utils/dayjsTz';
import { escapeAndLinkify } from '@/utils/sanitize';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import AbsenceModal from '@/components/modal/AbsenceModal.vue';
import PickupModal from '@/components/modal/PickupModal.vue';
import ChatMenu from '@/components/organisms/ChatMenu.vue';
import CalendarModal from '@/components/modal/CalendarModal.vue';

import { routeModule } from '@/store/entityModules/route';
import { meModule } from '@/store/entityModules/me';
import { chatModule } from '@/store/entityModules/chat';
import { familyModule } from '@/store/entityModules/family';
import { resourceModule } from '@/store/entityModules/resource';

// model
import {
  FetchChatsRequest,
  PostChatRequest,
  FetchHomeAbsenceRequest,
  PostHomeAbsenceRequest,
  FetchChatsChoicesRequest,
  FetchHomePickupRequest,
  PutHomePickupRequest,
  PostChatsConfirmRequest,
} from '@/model/Chat';
import {
  HomeChatResponse,
  HomeAbsenceResponse,
  HomePickupResponse,
  ChatChoiceResponse,
} from '@API/src/component/home/chat/types';
import {
  ChatResponse,
} from 'chaild-entity/lib';

//import Vue2TouchEvents from 'vue2-touch-events';
import { Toast } from '../service/SweetAlert';
import EmailSendModal from '@/components/modal/EmailSendModal.vue';
import TranslationModal from '@/components/modal/TranslationModal.vue';

//Vue.use(Vue2TouchEvents);
// Vue.component(VueHighlights.name, VueHighlights);

interface DataType {
  childId: number;
  childName: string;
  selectedDate: string;
  selectedChat: HomeChatResponse | null;
  selectedChatId: number | null;
  tabs: any;
  prevBadgeNum: number;
  nextBadgeNum: number;
  fetchLoading: boolean;
  postLoading: boolean;
  imgLoading: boolean;
  isAbsenceDialog: boolean;
  deleteAbsenceLoading: boolean;
  isPickupDialog: boolean;
  deletePickupLoading: boolean;
  isChatMenu: boolean;
  chatMenuX: number;
  chatMenuY: number;
  isAttachmentUrls: boolean;
  isImgDialog: boolean;
  notPdfImgSrc: string;
  showingUrls: Array<{
    url: string;
    objectKey: string;
  }>;
  chatWriting: string;
  showPicker: boolean;
  isCalendarDialog: boolean;
  calendar: string[];
  calendarDate: string;
  isEmailSendDialog: boolean;
  chatType: string;
  setTime: any;
  firstScroll: number;
  currentScroll: number;
  actionDialog: boolean;
  deleteDialog: boolean;
  deleteLoading: boolean;
  tempChat: ChatResponse;
  timeout: number;
  isTranslationDialog: boolean;
  translationChat: HomeChatResponse | null;
  translatedChats: Record<number, string>;
}

enum Reason {
  fever = 'fever', // 発熱
  personal = 'personal', // 家庭の事情
  infection = 'infection',
  others = 'others', // その他（コメントの入力が必要）
  infStrep = 'infStrep', // 溶連菌感染症
  infMycoplasma = 'infMycoplasma', // マイコプラズマ肺炎
  infHFMD = 'infHFMD', // 手足口病
  infSlappedCheek = 'infSlappedCheek', // 伝染性紅斑（りんご病）
  infStomach = 'infStomach', // ウイルス性胃腸炎（ノロ、ロタ、アデノ等）
  infHerpangina = 'infHerpangina', // ヘルパンギーナ
  infRS = 'infRS', // RSウィルス感染症
  infZoster = 'infZoster', // 帯状疱疹
  infRoseola = 'infRoseola', // 突発性発しん
  infImpetigo = 'infImpetigo', // 伝染性膿痂疹（とびひ）
  covid19 = 'covid19', // 新型コロナウイルス
}

export default defineComponent({
  components: {
    'vue-loading': Loading,
    VRuntimeTemplate,
    AbsenceModal,
    PickupModal,
    ChatMenu,
    CalendarModal,
    EmailSendModal,
    TranslationModal,
  },

  data: (): DataType => ({
    childId: 0,
    childName: '',
    selectedDate: dayjs().format('YYYY-MM-DD'),
    selectedChat: null,
    selectedChatId: null,
    tabs: null,
    prevBadgeNum: 0,
    nextBadgeNum: 0,
    fetchLoading: false,
    postLoading: false,
    imgLoading: false,
    isAbsenceDialog: false,
    deleteAbsenceLoading: false,
    isPickupDialog: false,
    deletePickupLoading: false,
    isChatMenu: false,
    chatMenuX: 0,
    chatMenuY: 0,
    isAttachmentUrls: false,
    isImgDialog: false,
    notPdfImgSrc: '',
    showingUrls: [],
    chatWriting: '',
    showPicker: false,
    isCalendarDialog: false,
    calendar: [],
    calendarDate: '',
    isEmailSendDialog: false,
    chatType: '',
    setTime: null as any,
    firstScroll: 0,
    currentScroll: 0,
    actionDialog: false,
    deleteDialog: false,
    deleteLoading: false,
    tempChat: {} as ChatResponse,
    timeout: 2000,
    isTranslationDialog: false,
    translationChat: null,
    translatedChats: {},
  }),

  computed: {
    isChatEnabled() {
      if (familyModule.family) {
        const children = familyModule.family.children;
        const child = children.find((c) => {
          if (c.childId === this.childId) {
            return c;
          }
        });
        if (!!child && child.nurserySettings.chat.isEnabled) {
          return child.nurserySettings.chat.isEnabled;
        }
      }
      return false;
    },
    isQuit() {
      if (familyModule.family) {
        const children = familyModule.family.children;
        const child = children.find((c) => {
          if (c.childId === this.childId) {
            return c;
          }
        });
        if (!!child && child.quitDate) {
          return dayjs(child.quitDate).isBefore(dayjs());
        }
      }
      return false;
    },
    appUrl(): string {
      if (process.env.VUE_APP_BASE_URL) {
        return process.env.VUE_APP_BASE_URL;
      }
      return '';
    },
    isSafeArea() {
      return isSafeAreaDisplay();
    },
    rules() {
      return rules;
    },
    me() {
      return meModule.me;
    },
    chatInput: {
      get(): string {
        return chatModule.chatInput;
      },
      set(value: string) {
        chatModule.setChatInput(value);
      },
    },
    chats(): HomeChatResponse[] {
      return chatModule.chatsSorted;
    },
    absence() {
      return chatModule.chatAbsence;
    },
    pickup() {
      return chatModule.chatPickup;
    },
    unReadCount() {
      return chatModule.unReadCount;
    },
    isEnglishLocale(): boolean {
      return locale === 'en';
    },
    prevDayUnreadBadgeOffsetX(): number {
      if (locale === 'en') return -140;
      if (locale === 'km') return -70;
      return -75;
    },
    dateNavUnreadBadgeOffsetY(): number {
      return locale === 'km' ? -24 : -20;
    },
    year(): string {
      return dayjs(this.selectedDate).format('YYYY');
    },
    today(): string {
      return t('record.date.monthDay', '', {
        day: dayjs(this.selectedDate).format('D'),
        month: dayjs(this.selectedDate).format('M'),
      });
    },
    dayOfTheWeek(): string {
      return dayjs(this.selectedDate).locale(locale).format('ddd');
    },
    iframeHeight() {
      return window.innerHeight - 56;
    },
  },

  watch: {
    chats: {
      async handler(val: boolean) {
        if (val) {
          this.$nextTick(() => {
            //pusherからchatsの更新があった時のみ（fetchLoading以外）画面更新
            if (!this.fetchLoading) {
              console.log("fetchChats")
              setTimeout(() => {
                this.fetchChats()
              }, 1000);
            }
            this.chatsScrollToBottom();
          });
        }
      },
      deep: true,
    },
    chatInput(newVal) {
    this.chatWriting = newVal;
    localStorage.setItem(this.childId + 'chatWriting', this.chatWriting);
    },
  },

  beforeRouteEnter(to, from, next) {
    routeModule.setPrevRoutePath(from.path);
    next();
  },

  methods: {
    t,
    translateParentRelationLabel,
    escapeAndLinkify,
    showLongText(body: string) {
      let replace = body.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
      const length = replace?.length;
      if (length > 150) {
        replace = replace.slice(0, 150) + '...';
        return replace;
      }
      return body;
    },
    handleContentClick(chat: ChatResponse, event) {
      if (event.target.tagName === 'A' && event.target.href) {
        const url = event.target.href;
        this.urlClicked(url);
        event.preventDefault();
        return;
      }
      if (event.currentTarget.classList.contains('autolinked')) {
        return;
      }
      this.selectedChatId = chat.chatId;
      this.chatType = chat.bodyType;
      this.setTime = setTimeout(() => this.activeModal(chat), 0);
    },
    activeModal(chat: ChatResponse) {
      if (this.firstScroll === this.currentScroll) {
        this.actionDialog = true;
        this.tempChat = chat;
      } else {
        console.log('first', this.firstScroll);
        console.log('current', this.currentScroll);
        this.currentScroll = this.firstScroll;
      }
      console.log('first', this.firstScroll);
      console.log('current', this.currentScroll);
      console.log('this.actionDialog', this.actionDialog);
    },
    async handleSendPdf(chat: HomeChatResponse) {
      this.selectedChat = chat;
      this.isEmailSendDialog = true;
    },

    sendEmailError(title: string) {
      Toast.fire({
        icon: 'error',
        title,
        customClass: {
          popup: 'swal-toast-front',
        },
      });
      this.isEmailSendDialog = false;
      this.selectedChat = null;
    },

    sendEmailSuccess(title: string) {
      Toast.fire({ icon: 'success', title });
      this.isEmailSendDialog = false;
      this.selectedChat = null;
    },
    urlClicked(url: string) {
      const ua = navigator.userAgent;
      const isIOS =
        ua.indexOf('iPhone') >= 0 ||
        ua.indexOf('iPad') >= 0 ||
        Number(navigator.userAgent.indexOf('iPod')) >= 0;
      if (isIOS && (window as any).webkit && (window as any).webkit.messageHandlers && (window as any).webkit.messageHandlers.openUrl) {
         console.log('WebView (iOS) environment detected. Calling webkit.messageHandlers.openUrl');
         (window as any).webkit.messageHandlers.openUrl.postMessage(url);
      } else {
         // Android、またはiOSの通常ブラウザ（Safariなど）の場合
         console.log('Standard browser or Android environment. Opening URL with window.open');
         window.open(url);
      }
    },
    routerBack() {
      if (routeModule.prevRoutePath) {
        this.$router.replace(routeModule.prevRoutePath);
        routeModule.setPrevRoutePath(null);
      } else {
        this.$router.replace('/record');
      }
    },
    toRecordByDay(
      path: string,
      name: string,
      childId: string,
      childName: string,
    ) {
      this.$router.push({
        query: {
          childId: String(this.childId),
          childName: this.childName,
          chatDate: this.selectedDate,
        }, path: "record/day"
      });
    },
    toNextDate() {
      this.selectedDate = dayjs(this.selectedDate)
        .add(1, 'day')
        .format('YYYY-MM-DD');

      this.$router.replace({
        query: {
          ...this.$route.query,
          date: this.selectedDate
        }
      });
      this.fetchCalendar();
      this.selectedCalendarDate();
      this.fetchChats();
    },
    toPrevDate() {
      this.selectedDate = dayjs(this.selectedDate)
        .add(-1, 'day')
        .format('YYYY-MM-DD');

      this.$router.replace({
        query: {
          ...this.$route.query,
          date: this.selectedDate
        }
      });
      this.fetchCalendar();
      this.selectedCalendarDate();
      this.fetchChats();
    },
    //チャットの日付を配列に格納 (CalendarModal.vueで使用)
    async selectedCalendarDate(){
      this.calendarDate = this.selectedDate;
    },
    //未読日を取得する
    async fetchCalendar() {
      this.calendar = [];

      const date = new Date(this.selectedDate); //選択されている日付をstring型からdate型に変換
      const firstDate = dayjs(new Date(date.getFullYear(), date.getMonth() + 1, 1)).format('YYYY-MM-DD'); //選択されている日付の翌月の最初の日を取得 (例：2024-12-01)
      const lastDate = dayjs(firstDate).add(-1, 'day').format('YYYY-MM-DD'); //選択されている日付の月の最後の日を取得 (例：2024-11-30)
      const num = new Date(lastDate).getDate(); //日数の取得

      const data = chatModule.fetchCalendar({
        childId: this.childId,
        year: new Date(date).getFullYear(),
        month: Number(dayjs(date).format('MM')),
        date: `${num}`,
      });

      const arr = await Promise.all([data]);
      this.calendar = Array.isArray(arr[0]?.data) ? arr[0].data : [];
    },
    async fetchChats() {
      this.fetchLoading = true;
      const fetchChatsFunc = chatModule.fetchChats({
        childId: this.childId,
        date: this.selectedDate,
      });
      const fetchAbsenceFunc = chatModule.fetchHomeAbsence({
        childId: this.childId,
        date: this.selectedDate,
      });
      const fetchPickupFunc = chatModule.fetchHomePickup({
        childId: this.childId,
        date: this.selectedDate,
      });
      await Promise.all([fetchChatsFunc, fetchAbsenceFunc, fetchPickupFunc]);
      this.$nextTick(() => {
        this.fetchLoading = false;
        setTimeout(() => {
          this.chatsScrollToBottom();
        }, 350);
        const filteredChats = this.chats.filter((c) => {
          if (c.from !== null) {
            return c;
          }
        });
        const chatIds = filteredChats.map((f) => {
          return f.chatId;
        });
        if (chatIds?.length) {
          chatModule.postChatsConfirm({ chatIds });
        }
      });
    },
    openCalendarModal() {
      this.fetchCalendar();
      this.isCalendarDialog = true;
    },
    closeCalendarModal() {
      this.isCalendarDialog = false;
    },
    async postChats() {
      if (this.chatInput && this.childId) {
        this.postLoading = true;
        await chatModule.postChats({
          childId: this.childId,
          date: dayjs(this.selectedDate).format('YYYY-MM-DD'),
          body: this.chatInput,
        });
        this.postLoading = false;
        this.chatInput = '';
        this.$nextTick(() => {
          this.chatsScrollToBottom();
        });
      }
      localStorage.removeItem(this.childId + 'chatWriting');
    },
    onCopyTextCopy() {
      console.log(this.tempChat);
      navigator.clipboard.writeText(this.tempChat.body).catch(e => {
        console.error(e);
      });
      this.actionDialog = false;
      Toast.fire({
        icon: 'success',
        title: this.t('chat.toast.copied'),
      });
    },
    async deleteChat() {
      this.isChatMenu = false;
      if (this.selectedChat) {
        const response = await chatModule.deleteChat({
          chatId: this.selectedChat.chatId,
        });
        this.selectedChat = null;
        Toast.fire({
          icon: 'success',
          title: this.t('chat.toast.deleteCompleted'),
        });
      }
    },
    async deleteChatById() {
      this.deleteDialog = false;
      if (this.selectedChatId) {
        const response = await chatModule.deleteChat({
          chatId: this.selectedChatId,
        });
        this.selectedChatId = null;
        Toast.fire({
          icon: 'success',
          title: this.t('chat.toast.deleteCompleted'),
        }).then((result) => {
          this.fetchChats();
        });
      }
    },
    async deleteAbsence() {
      this.deleteAbsenceLoading = true;
      await chatModule.deleteAbsence({
        childId: this.childId,
        date: dayjs(this.selectedDate).format('YYYY-MM-DD'),
      });
      this.deleteAbsenceLoading = false;
      Toast.fire({
        icon: 'success',
        title: this.t('chat.toast.deleteCompleted'),
      });
    },
    async deletePickup() {
      this.deletePickupLoading = true;
      await chatModule.deletePickup({
        childId: this.childId,
        date: dayjs(this.selectedDate).format('YYYY-MM-DD'),
      });
      this.deletePickupLoading = false;
      Toast.fire({
        icon: 'success',
        title: this.t('chat.toast.deleteCompleted'),
        target: document.body,
      });
    },
    formatMinutes(time: string): string {
      return formatChatTime(time, this.selectedDate);
    },
    formatPickupTime,
    chatsScrollToBottom() {
      const selectedElement: Element =
        document.getElementsByClassName('wrapper')[0];
      selectedElement.scrollTop = selectedElement.scrollHeight;
    },
    showChatMenu(chat: HomeChatResponse) {
      return (direction: TouchEvent, event) => {
        if (chat.from === null) {
          this.chatMenuX = direction.changedTouches[0].clientX - 60;
          this.chatMenuY = direction.changedTouches[0].clientY - 40;
          this.selectedChat = chat;
          this.isChatMenu = !this.isChatMenu;
        }
      };
    },
    insertStr(str, index, insert) {
      return str.slice(0, index) + insert + str.slice(index, str?.length);
    },
    formatAmzIso(dateStr: string): string {
      let formatted = dateStr;
      formatted = this.insertStr(formatted, 4, '-');
      formatted = this.insertStr(formatted, 7, '-');
      formatted = this.insertStr(formatted, 13, ':');
      formatted = this.insertStr(formatted, 16, ':');
      return formatted;
    },
    isPresignedUrlExpired(url: string): boolean {
      try {
        const expiresFromIndex = url.indexOf('?Expires=') + 9;
        const expiresEndIndex = url.indexOf('&Key-Pair-Id=');
        const expires = Number(
          url.substring(expiresFromIndex, expiresEndIndex),
        );
        if (expires) {
          const Now = dayjs();
          const isExpired = Now.isAfter(dayjs.unix(expires));
          return isExpired;
        } else {
          return true;
        }
      } catch (error) {
        return true;
      }
    },
    isPdf(objectKey: string) {
      const arr = objectKey.split('.');
      const ext = arr[arr?.length - 1];
      if (ext === 'pdf') {
        return true;
      }
      return false;
    },
    openPdfLink(url: string) {
      // iOS判定
      const ua = navigator.userAgent;
      const isIOS =
        ua.indexOf('iPhone') >= 0 ||
        ua.indexOf('iPad') >= 0 ||
        ua.indexOf('iPod') >= 0;
      if (isIOS) {
        // iOS WKWebView は window.open(...) を呼んでも
        // そのままでは外部ブラウザが開かない可能性が高い
        // それでも一応トライしてみる
        window.open(url, '_blank');
      } else {
        // Android など 他OS の WebView / PCブラウザ なら
        // これだけで別タブ(外部ブラウザ相当)が開くことがある
        window.open(url, '_blank');
      }
    },
    async openChatImg(chat: HomeChatResponse, index: number) {
      const target = chat.attachmentUrls?.[index];
      if (!target) return;

      let img = target.url;
      const isPdf = this.isPdf(chat.attachmentUrls[index].objectKey);
      if (isPdf) {
        const isImgExpired = this.isPresignedUrlExpired(
          chat.attachmentUrls[index].url,
        );
        if (isImgExpired) {
          this.imgLoading = true;
          const objectKey = chat.attachmentUrls[index].objectKey;
          const imgContent = await resourceModule.postResourceDownload({
            objectKey,
          });
          img = imgContent.preSignedUrl;
          this.imgLoading = false;
        }
        const ua = navigator.userAgent;
        const isIOS =
          ua.indexOf('iPhone') >= 0 ||
          ua.indexOf('iPad') >= 0 ||
          Number(navigator.userAgent.indexOf('iPod')) >= 0;
        if (isIOS) {
          if ((window as any).webkit.messageHandlers) {
            (window as any).webkit.messageHandlers.pdf.postMessage(`${[img]}`);
          }
        } else {
          this.isAttachmentUrls = true;
          this.showingUrls = [
            {
              url: img,
              objectKey: chat.attachmentUrls[index].objectKey,
            },
          ];
        }
      } else {
        // let img = chat.attachmentUrls[0].url;
        const isImgExpired = this.isPresignedUrlExpired(
          chat.attachmentUrls[index].url,
        );
        if (isImgExpired) {
          const objectKey = chat.attachmentUrls[index].objectKey;
          const imgContent = await resourceModule.postResourceDownload({
            objectKey,
          });
          img = imgContent.preSignedUrl;
        }
        this.notPdfImgSrc = img;
        this.isImgDialog = true;
      }
    },
    formatReason(reason: Reason) {
      switch (reason) {
        case Reason.fever:
          return t('chat.absence.reasons.fever');
        case Reason.personal:
          return t('chat.absence.reasons.personal');
        case Reason.infection:
          return t('chat.absence.reasons.infection');
        case Reason.others:
          return t('chat.absence.reasons.others');
        case Reason.infStrep:
          return t('chat.absence.reasons.infStrep');
        case Reason.infMycoplasma:
          return t('chat.absence.reasons.infMycoplasma');
        case Reason.infHFMD:
          return t('chat.absence.reasons.infHFMD');
        case Reason.infSlappedCheek:
          return t('chat.absence.reasons.infSlappedCheek');
        case Reason.infStomach:
          return t('chat.absence.reasons.infStomach');
        case Reason.infHerpangina:
          return t('chat.absence.reasons.infHerpangina');
        case Reason.infRS:
          return t('chat.absence.reasons.infRS');
        case Reason.infZoster:
          return t('chat.absence.reasons.infZoster');
        case Reason.infRoseola:
          return t('chat.absence.reasons.infRoseola');
        case Reason.infImpetigo:
          return t('chat.absence.reasons.infImpetigo');
        case Reason.covid19:
          return t('chat.absence.reasons.covid19');
        default:
          return t('common.unknown');
      }
    },
    closeChatImg() {
      this.isAttachmentUrls = false;
      this.showingUrls = [];
    },
    async dateSelected(date: string) {
      // 1. まず日付を更新
      this.selectedDate = dayjs(date).format('YYYY-MM-DD');

      try {
        // 2. データの更新を順番に待ち、すべて完了させる
        // これにより「中途半端なデータ」が子に渡るのを防ぎます
        await this.fetchCalendar();
        await this.selectedCalendarDate();
        await this.fetchChats();
      } catch (e) {
        console.error("データ取得エラー:", e);
      } finally {
        // 3. すべてのデータ準備が整ってから、最後にダイアログを閉じる
        this.isCalendarDialog = false;
      }
    },
    openTranslateDialog(chat: HomeChatResponse) {
      // グループチャットはタイトルと本文を「タイトル\n本文」で翻訳・保存する（ReferenceDetailと共通形式）
      this.translationChat =
        chat.bodyType === 'groupChat' && chat.title
          ? { ...chat, body: `${chat.title}\n${chat.body}` }
          : chat;
      this.isTranslationDialog = true;
    },
    // 翻訳済みなら翻訳後の本文を返す（グループチャットは1行目のタイトルを除く）
    displayChatBody(chat: HomeChatResponse): string {
      const translated = this.translatedChats[chat.chatId];
      if (!translated) return chat.body;
      if (chat.bodyType === 'groupChat' && chat.title) {
        const idx = translated.indexOf('\n');
        return idx === -1 ? '' : translated.slice(idx + 1);
      }
      return translated;
    },
    getTranslatedChatsKey(): string {
      return `translatedChats_${this.childId}`;
    },
    loadTranslatedChats() {
      try {
        const raw = localStorage.getItem(this.getTranslatedChatsKey());
        this.translatedChats = raw ? JSON.parse(raw) : {};
      } catch {
        this.translatedChats = {};
      }
    },
    saveTranslatedChats() {
      try {
        localStorage.setItem(this.getTranslatedChatsKey(), JSON.stringify(this.translatedChats));
      } catch (error) {
        console.error('Translated chats save error:', error);
      }
    },
    onTranslated(chat: HomeChatResponse, translatedText: string) {
      this.translatedChats[chat.chatId] = translatedText;
      // 上限を超えたら古いメッセージ（chatIdが小さいもの）から削除する
      const MAX_TRANSLATED_CHATS = 50;
      const chatIds = Object.keys(this.translatedChats)
        .map(Number)
        .sort((a, b) => a - b);
      const overflow = chatIds.length - MAX_TRANSLATED_CHATS;
      for (let i = 0; i < overflow; i++) {
        delete this.translatedChats[chatIds[i]];
      }
      this.saveTranslatedChats();
    },
    returnTranslate(chatId: number) {
      delete this.translatedChats[chatId];
      this.saveTranslatedChats();
    },
    clickDeleteDialog(chat: ChatResponse) {
      this.actionDialog = false;
      this.deleteDialog = true;
      this.tempChat = chat;
    },
  },

  async mounted() {
    if (typeof this.$route.query.date === 'string') {
      this.selectedDate = dayjs(this.$route.query.date).format('YYYY-MM-DD');
    }
    if (typeof this.$route.query.childName === 'string') {
      this.childName = this.$route.query.childName;
    }
    if (typeof this.$route.query.childId === 'string') {
      this.childId = Number(this.$route.query.childId);

      this.loadTranslatedChats();
      this.fetchCalendar();
      this.selectedCalendarDate();
      this.fetchChats();
    } else {
      this.routerBack();
    }
    // ページが読み込まれたときにローカルストレージからchatWritingを読み込む
    console.log(this.childId)
    const savedChatWriting = localStorage.getItem(this.childId + 'chatWriting');
    console.log(this.childId + 'chatWriting')
    if (savedChatWriting !== null) {
      this.chatWriting = savedChatWriting;
      this.chatInput = this.chatWriting; // チャット入力エリアを更新
    }
  },
});
</script>
<style lang="scss" scoped>
@use '../sass/ress.scss';
@use '../sass/variables.scss';

.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

.outline {
  border: 1px solid rgb(var(--v-theme-primary));
}
/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

@media (max-width: 399px) {
  .chat-toolbar-child-name {
    max-width: calc(100% - 120px) !important;
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(env(safe-area-inset-top));
}
.wrapper {
  &::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }
  .grey-border {
    height: 2px;
    width: 100%;
    background-color: #f5f6f6;
  }

  .chats-wrapper {
    margin-top: 130px;
    position: relative;
    padding-bottom: 80px;
    width: 100%;
    min-height: calc(100% - 181px - 56px);
    overflow-y: hidden;

    .chat_menu-wrapper {
      height: 100vh;
      width: 100vw;
      .chat_menu {
        background-color: #424242;
        min-height: 40px;
        min-width: 60px;
        border-radius: 15%;
      }
    }

    .chat-wrapper {
      max-width: 100%;

      .info-wrapper {
        width: 100%;
        border: 2px solid rgb(var(--v-theme-primary));
        border-radius: 5px 5px;
        // p {
        //   color: rgb(var(--v-theme-success));
        // }
      }

      .message-wrapper {
        width: 100%;
        .chat-body {
          width: auth;
          border-radius: 5px;
        }
        .staff-chat {
          max-width: 85%;
          min-width: 0;
          background-color: #f5f6f6;
          white-space: pre-wrap;
          .autolinked ::v-deep .highlights {
            color: #0000ff;
          }
        }
        .parents-chat {
          max-width: 80%;
          min-width: 0;
          background-color: rgb(var(--v-theme-primary));
          color: #fff;
          align-self: flex-end;
          p {
            max-width: 100%;
            white-space: pre-wrap;
            word-wrap: break-word;
          }
          .autolinked ::v-deep .highlights {
            max-width: 100%;
            color: #0000ff;
          }
        }
        .group-chat {
          border: 2px solid #80deea;
          border-radius: 5px 5px;
        }
      }
    }
  }

  .input-wrapper {
    position: fixed;
    bottom: 0px;
    width: 100%;
    max-height: 100%;
    min-height: 52px;
    overflow-y: scroll;
    scrollbar-width: none;
    z-index: 2;
    background-color: #ffffff;
    overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
      -webkit-appearance: none;
    }
    padding: 4px;
    @supports (bottom: env(safe-area-inset-bottom)) {
      padding-bottom: env(safe-area-inset-bottom);
    }

    .chat_textarea {
      margin: 2px 4px 0;
    }

    .btn-wrapper {
      width: 74px;
      padding: 2px;
    }
    .send-button {
      align-self: flex-end;
      position: fixed;
      right: 3px;
      bottom: 3px;
      @supports (bottom: env(safe-area-inset-bottom)) {
        bottom: calc(env(safe-area-inset-bottom) + 5px);
      }
    }
  }
}

.pdf_wrapper {
  height: 100%;
  height: calc(var(--vh, 1vh) * 100);
  overflow-y: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }
}
.pdf_header_wrapper {
  height: 56px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
    // top: env(safe-area-inset-top);
  }
}
.pdf {
  height: 100%;
  width: 100%;
  padding-top: 56px;
  overflow: scroll;
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: calc(env(safe-area-inset-top) + 64px);
  }
  img {
    display: block;
    height: 200%;
    width: 200%;
  }
}
.img_dialog {
  .img_dialog-header {
    margin-top: 30px;
    @supports (bottom: env(safe-area-inset-bottom)) {
      margin-top: calc(env(safe-area-inset-top) + 15px);
    }
  }
}

/* 1. カーソルの色をプライマリに変更 */
.chat_textarea :deep(textarea) {
  caret-color: rgb(var(--v-theme-primary)) !important;
}

/* 2. 非アクティブ時の枠線の不透明度を調整（真っ黒にする場合） */
.chat_textarea :deep(.v-field__outline) {
  --v-field-border-opacity: 1 !important;
}

/* 3. フォーカス時に背景を確実に白くする設定 */
.chat_textarea :deep(.v-field--focused) {
  background-color: white !important;
}
.meta {
  display: flex;
  flex-direction: column;
  justify-content: flex-end; // ← 下に寄せる（重要）
  align-items: stretch;
  margin-left: 4px;
  flex-shrink: 0;
  min-width: 36px;
}
.meta p {
  width: 100%;
  text-align: right;
  margin: 0;
  line-height: 1.2;
}

.chat-date-nav {
  position: relative;
  display: grid;
  /* Left/right columns match button widths so "center" is between PREVIOUS and NEXT */
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto 35px;
  align-items: center;
  width: 100%;
}

.chat-date-nav-year {
  /* Span full bar so the year is centered on the screen, not only in the middle grid track */
  grid-column: 1 / -1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-date-nav-year h5 {
  margin: 0;
  padding: 0;
}

.chat-date-nav-side {
  display: flex;
  align-items: center;
  min-width: 0;
  /* v-badge may be offset outside the button, so allow it to be visible */
  overflow: visible;
}

.chat-date-nav-side-left {
  justify-content: flex-start;
  padding-left: 2px;
  justify-self: start;
  /* Lock width so PREVIOUS DAY text doesn't shift based on the center date length */
  min-width: max-content;
}

.chat-date-nav-side-right {
  justify-content: flex-end;
  padding-right: 2px;
  justify-self: end;
  /* Lock width so NEXT DAY text doesn't shift based on the center date length */
  min-width: max-content;
}

.chat-date-nav-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 6px;
  min-width: 0;
  overflow: hidden; /* Prevent layout shifts when the center date is long */
}

.chat-date-nav-date {
  min-width: 0;
  /* Vuetify `align-end` can pull the date group down */
  align-items: center !important;
  white-space: nowrap; /* Prevent wrapping like 12/29 (Thu) on small screens */
}

.chat-date-nav-date h3,
.chat-date-nav-date p {
  margin: 0;
  line-height: 1.1;
}

.chat-date-nav-calendar {
  align-self: flex-end;
}

.chat-title-custom {
  transform: translateX(-50%);
}

@media (max-width: 430px) {
  .chat-title-custom {
    transform: translateX(-55%);
  }
}

@media (max-width: 360px) {
  .chat-date-nav {
    grid-template-rows: auto 40px !important; /* Prevent cutting the date nav area on narrow screens */
  }

  .chat-date-nav-date h3 {
    font-size: 16px !important;
  }

  .chat-date-nav-date p {
    font-size: 12px !important;
  }

  .chat-date-nav-center {
    gap: 4px;
  }

  .chat-date-nav-date {
    align-items: center !important;
  }

  /* Reduce padding so PREVIOUS/NEXT text doesn't overflow/cut at ~320px width */
  .chat-date-nav-side .v-btn {
    padding-left: 0 !important;
    padding-right: 0 !important;
    min-width: 0 !important;
  }

  /* Make the calendar icon smaller so it doesn't take space or misalign on small screens */
  .chat-date-nav-calendar {
    font-size: 20px !important;
    width: 20px !important;
    height: 20px !important;
    margin-bottom: 1px; /* align vertically with the text */
  }

  /* Shrink PREVIOUS DAY / NEXT DAY text to keep room for the center date */
  .chat-date-nav-side .v-btn .text-subtitle-1 {
    font-size: 14px !important;
    line-height: 1;
    white-space: nowrap;
  }

  .badge-prev-day-en-custom :deep(.v-badge__wrapper .v-badge__badge) {
    left: calc(100% + 115px) !important;
  }
}
</style>
